// extracted by mini-css-extract-plugin
export default {"SpinningLoader":"Dgv5GiaZToo72EclXfd77w==","rotate360":"DsYvfASgzKbvNmj6GRybrw=="};